import { Global, LineOverOrdersPhase } from '../../model';
export class NewValuesTooltipOrdersPhase {
  static set(newVal = {}, overOrdersPhase: LineOverOrdersPhase){
    newVal['planner_tooltip_orders_phase'] = {
      colorcode:      overOrdersPhase.colorcode,
      description:    overOrdersPhase.description,
      unit_price:     overOrdersPhase.unit_price,
      material:       overOrdersPhase.material,
      heat_treatment: overOrdersPhase.heat_treatment
    }
  }
}
